import styled from '@emotion/styled'
import { Box } from '@chakra-ui/react'
import { mq } from '@lib/hooks'
import theme from '@styles/theme'

export const Header = styled(Box)`
  position: fixed;
  top: 0;
  height: 49px;
  transition: all 0.3s ease;
  background-color:#fff;

  &.Header--hide {
    top: ${theme.sizes.header.negative};
  }

  &.Header--secondary,
  &.Header--sticky {
    background-color: #fff;
  }

  &.Header--sticky + * {
    padding-top: 49px;
  }
  & > .Header__Inner {
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;

    .Header__Nav {
      ${mq('lg')} {
        z-index: 2;
      }
    }
  }

  .styles__NavItem {
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: ${theme.colors.black.primary3};
    padding: 0px;
    user-select: none;
    display: flex;
    align-items: center;
  }

  .Header__SSMLogo {
    visibility: hidden;
    opacity: 0;
    transition: all 0.25s linear;
    transform: translateY(-20px);
  }

  .Header__SSMLogo--visible {
    visibility: visible;
    opacity: 1;
    transform: translateY(0px);
  }

  .Header__SSMBigLogo {
    display: block;
    position: absolute;
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
    transition: all 0.25s linear;

    ${mq('lg')} {
      top: 15px;
      width: 100%;
      max-width: ${theme.sizes.container.xl};
      padding: 0px ${theme.space.padding.primary};
    }

    ${mq('base')} {
    }

    &.Header__SSMBigLogo--hidden {
      top: 100px;

      ${mq('lg')} {
        top: -8px;
      }
    }
  }
`

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Header__Overlay = styled.div`
  width: 100%;
  height: 100px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.65) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  mix-blend-mode: normal;
  position: absolute;
  top: 40px;
  visibility: visible;
  opacity: 1;
  transition: all 0.3s ease;

  ${mq('lg')} {
    height: 252px;
    top: 0px;
  }

  &.Header__Overlay--hidden {
    visibility: hidden;
    opacity: 0;
  }

  .Header__SSMBigLogo__Icon {
    @media screen and (max-width: 375px) {
      max-width: 320px;
      display: none;
    }
  }
`
